module.exports = __webpack_public_path__ + "img/personal-details.b15f72e5.svg";